import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wip-contact',
  templateUrl: './wip-contact.component.html',
  styleUrls: ['./wip-contact.component.scss']
})
export class WipContactComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
